import React from "react";
import * as ReactDOMClient from "react-dom/client";
import * as ReactDOM from "react-dom";
import "./index.css";
import { ChatWidget, ChatWidgetInit } from "./components/ChatWidget";
import type { ChatWidgetConfig } from "./components/ChatWidget";

// Expose React and ReactDOM globally for the widget
declare global {
  interface Window {
    React?: typeof React;
    ReactDOM?: typeof ReactDOM & typeof ReactDOMClient;
    ChatWidgetInit?: typeof ChatWidgetInit;
    NopalChatWidget?: {
      ChatWidget: typeof ChatWidget;
      ChatWidgetInit: typeof ChatWidgetInit;
      init: typeof ChatWidgetInit.init;
    };
  }
}

window.React = React;
window.ReactDOM = { ...ReactDOM, ...ReactDOMClient } as any;

// Expose ChatWidget components globally for external usage
window.ChatWidgetInit = ChatWidgetInit;
window.NopalChatWidget = {
  ChatWidget,
  ChatWidgetInit,
  init: ChatWidgetInit.init,
};

// Log successful initialization
console.log("[NopalChatWidget] Widget loaded and available globally");

export { ChatWidget, ChatWidgetInit };
export type { ChatWidgetConfig };
